import { render, staticRenderFns } from "./TrafficFineOttDetail.vue?vue&type=template&id=2b29cab6&scoped=true&"
import script from "./TrafficFineOttDetail.vue?vue&type=script&lang=js&"
export * from "./TrafficFineOttDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrafficFineOttDetail.vue?vue&type=style&index=0&id=2b29cab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b29cab6",
  null
  
)

export default component.exports